import React from "react";
import axiosClient from "@service/axiosClient";
import AddPhotoAlternateIconOutlined from "@mui/icons-material/AddPhotoAlternateOutlined";

const UploadPhotoButton = ({ onUploadSuccess, userId }) => {
  // console.log(userId);
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("user_id", userId);

      try {
        const response = await axiosClient.post(
          "/file/profile_image/upload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 200) {
          onUploadSuccess(response.data.user_image_url);
        } else {
          console.error("Failed to upload image");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  return (
    <div className="upload-photo-button">
      <input
        type="file"
        id={`file-input-${userId}`}
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <label htmlFor={`file-input-${userId}`}>
        <AddPhotoAlternateIconOutlined className="add-icon" />
      </label>
    </div>
  );
};

export default UploadPhotoButton;
